import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b44284c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-listen" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = {
  key: 0,
  class: "text-intro"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]

import BigButton from "@/components/inputs/BigButton";
import IconButton from "@/components/inputs/IconButton";
import AudioSpectrogram from "@/components/AudioSpectrogram";
import SpriteIcon from "@/components/SpriteIcon";
import NotificationContainer from "@/components/NotificationContainer";
import BufferingNotification from "@/components/BufferingNotification";

import { computed, inject, onMounted, onUnmounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import { t } from "@/lib/i18n";

import australiaJson from "@/assets/audio/countries/australia.json";
import maldivesJson from "@/assets/audio/countries/maldives.json";
import indonesiaJson from "@/assets/audio/countries/indonesia.json";
import polynesiaJson from "@/assets/audio/countries/polynesia.json";
import panamaJson from "@/assets/audio/countries/panama.json";
import belgiumJson from "@/assets/audio/countries/belgium.json";
import floridaJson from "@/assets/audio/countries/florida.json";
import canadaJson from "@/assets/audio/countries/canada.json";
import swedenJson from "@/assets/audio/countries/sweden.json";
import kenyaJson from "@/assets/audio/countries/kenya.json";
import philippinesJson from "@/assets/audio/countries/philippines_280723.json";

import mexicoJson from "@/assets/audio/countries/mexico.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListenView',
  setup(__props) {

const bus = inject("bus");

const store = useStore();
const router = useRouter();

const showToast = ref(false);

const loading = ref(true);
const audio = ref("");
const audioSpectrogram = ref(null);

const audioSuspended = ref(false);
const audioActive = ref(false);

const buttonText = computed(() => t(store, "listen.button_text"));
const toastText = computed(() => t(store, "listen.toast"));
const introText = computed(() => t(store, "listen.intro"));

const skipText = t(store, "video.actions.skip");
const isRTL = computed(() => document.body.classList.contains("rtl"));

let timeout: number;

const devMode = process.env.NODE_ENV === "development";

const showIntroText = ref(true);
const showBigButton = ref(false);

function showSkip() {
  return devMode;
}

const preloadAsset = ({ type, path }) => {
  if (type === "AUDIO") {
    return store.dispatch("getAudio", path);
  }
};

let countries = {};
countries["selection.indonesia"] = indonesiaJson;
countries["selection.maldives"] = maldivesJson;
countries["selection.kenya"] = kenyaJson;
countries["selection.mexico"] = mexicoJson;
countries["selection.australia"] = australiaJson;
countries["selection.frenchpolynesia"] = polynesiaJson;
countries["selection.belgium"] = belgiumJson;
countries["selection.florida"] = floridaJson;
countries["selection.panama"] = panamaJson;
countries["selection.sweden"] = swedenJson;
countries["selection.canada"] = canadaJson;
countries["selection.phillipines"] = philippinesJson;

// for each key in countries, change url
for (var key in countries) {
  for (var i = 0; i < countries[key].length; i++) {
    countries[key][i] = countries[key][i].replace(
      "./export/",
      //process.env.BASE_URL + "data/samples/"
      "/samples/"
    );
  }
}

let nTaps = 0;

onMounted(() => {
  setTimeout(() => {
    showIntroText.value = false;
    setTimeout(async () => {
      showBigButton.value = true;

      console.log(path);
      try {
        // Extract JSON from the URL /su/{path}
        const response = await fetch(`su/${path}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const jsonResponse = await response.json();
        const url = jsonResponse.url;
        console.log(url);
        preloadAsset({ type: "AUDIO", path: url })
          .then(() => {
            loading.value = false;
            audio.value = url;
            console.log(url);
          })
          .catch((error) => {
            console.error("Error preloading asset:", error);
          });
      } catch (error) {
        console.error("Error fetching JSON:", error);
      }
    }, 1000);
  }, 3000);

  /*

  setTimeout(() => {
    showIntroText.value = false;
    setTimeout(async () => {
      showBigButton.value = true;

      console.log(path);

      preloadAsset({ type: "AUDIO", path })
        .then(() => {
          loading.value = false;
          audio.value = path;
        })
        .catch((error) => {
          console.error("Error preloading asset:", error);
        });
    }, 1000);
  }, 3000);
  */
  // Merge all three JSON in the same array, ordered by a key
  audioActive.value = true;

  const audioNames = countries[store.state.selectedAudioLocation];
  let path = audioNames[(audioNames.length * Math.random()) | 0];
  console.log(path);
  loading.value = true;
});

onUnmounted(() => {
  audioActive.value = false;
});

function onSkip() {
  bus.publish({
    event: "TRACK",
    data: {
      action: "<location> - skip audio",
      label: audio.value,
      value: nTaps,
    },
  });

  audioEnded();
}

function onButtonClicked() {
  if (audioSuspended.value) {
    iosUserInteraction();
  }

  audioSpectrogram.value.drawLine();

  const pressedAt = audioSpectrogram.value.currentTime();
  if (pressedAt > 0) {
    console.log("pressedAt: " + pressedAt);
    bus.publish({
      event: "TAG_AUDIO",
      data: {
        trackName: audio.value,
        pressedAt: pressedAt,
      },
    });
  }

  showToast.value = true;

  if (timeout) {
    clearTimeout(timeout);
  }

  timeout = setTimeout(() => {
    showToast.value = false;
  }, 2000);

  nTaps++;
}

function audioStarted() {
  bus.publish({
    event: "TRACK",
    data: {
      action: "<location> - play audio",
      label: audio.value,
    },
  });

  audioActive.value = true;

  /*
    // Check if audio awaiting user interaction (ios)
    setTimeout(() => {
      if (audioSpectrogram.value.iosAwaitingUserInteraction()) {
        audioSuspended.value = true
      }
    }, 100)
    */
}

function audioEnded() {
  bus.publish({
    event: "TRACK",
    data: {
      action: "<location> - finish audio",
      label: audio.value,
      value: nTaps,
    },
  });

  audioActive.value = false;
  router.push({
    name: "active.listen-again",
    query: { audioFileName: audio.value },
  });
}

function iosUserInteraction() {
  audioSuspended.value = false;
  audioSpectrogram.value.iosPlay();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      showSkip
        ? (_openBlock(), _createBlock(_unref(IconButton), {
            key: 0,
            name: "submit",
            class: _normalizeClass({ 'skip-button': true, 'header-button': true, rtl: _unref(isRTL) }),
            priority: "secondary",
            onClick: onSkip
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(skipText)), 1)
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "toast" }, {
        default: _withCtx(() => [
          (showToast.value)
            ? (_openBlock(), _createBlock(_unref(NotificationContainer), {
                key: 0,
                class: "toast"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(toastText)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_unref(AudioSpectrogram), {
        ref_key: "audioSpectrogram",
        ref: audioSpectrogram,
        audio: audio.value,
        onAudioStarted: _cache[0] || (_cache[0] = ($event: any) => (audioStarted())),
        onAudioEnded: _cache[1] || (_cache[1] = ($event: any) => (audioEnded()))
      }, null, 8, ["audio"]),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (showIntroText.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(introText)), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (showBigButton.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (!loading.value)
                  ? (_openBlock(), _createBlock(_unref(BigButton), {
                      key: 0,
                      class: "big-button",
                      "audio-active": audioActive.value,
                      onPressed: onButtonClicked
                    }, {
                      default: _withCtx(() => [
                        (audioSuspended.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                              _createVNode(_unref(SpriteIcon), {
                                name: "play",
                                class: "icon play-icon"
                              })
                            ]))
                          : (audioActive.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                innerHTML: _unref(buttonText)
                              }, null, 8, _hoisted_6))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["audio-active"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (showBigButton.value)
        ? (_openBlock(), _createBlock(_unref(BufferingNotification), {
            key: 1,
            active: loading.value,
            class: "loading"
          }, null, 8, ["active"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})